/** @format */

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const formatDateOfBirth = (person: any): string => {
  if (!person) return 'N/A';
  
  const dateOfBirth = person.dateOfBirth || person.dob;
  if (!dateOfBirth) return 'N/A';

  const date = dayjs.utc(dateOfBirth);
  if (!date.isValid()) return 'N/A';
  
  return date.format('MM/DD/YYYY');
};

export const getStatusStyle = (status?: string) => {
  switch (status) {
    case 'Paid':
      return { backgroundColor: 'green', color: 'white', padding: '1px 4px' };
    case 'Pending':
      return { backgroundColor: 'yellow', color: 'black', padding: '1px 4px' };
    case 'Declined':
      return { backgroundColor: 'red', color: 'white', padding: '1px 4px' };
    case 'Cancelled':
      return { backgroundColor: 'gray', color: 'white', padding: '1px 4px' };
    case 'Missing Info/TLO':
      return { backgroundColor: 'yellow', color: 'black', padding: '1px 4px' };
    case 'Contact Required':
      return { backgroundColor: 'red', color: 'white', padding: '1px 4px' };
    case 'SRE':
      return { backgroundColor: 'yellow', color: 'black', padding: '1px 4px' };
    default:
      return { backgroundColor: 'red', color: 'white', padding: '1px 4px' };
  }
};
